import { v4 as uuidv4 } from 'uuid';
import Bg1 from '../../assets/img/home1/eng.jpg';
import Bg3 from '../../assets/img/home1/eng2.jpg';
import Bg4 from '../../assets/img/home1/gas.jpg';
import Bg2 from '../../assets/img/home1/power.jpg';
import Icon1 from '../../assets/img/icon/s1.png';
import Icon2 from '../../assets/img/icon/s2.png';
import Icon3 from '../../assets/img/icon/s3.png';
import Icon4 from '../../assets/img/icon/s4.png';

const servicesOneData = [
    {
        id: uuidv4(),
        bgImg: Bg1,
        icon: Icon1,
        heading: 'CAD Design & 3D Scanning',
        text: 'Expert computer-aided design and precision 3D scanning services for accurate digital representations of your concepts and existing components.',
        btnText: 'Learn More',
        link: '/services/cad-design-3d-scanning',
    },

    {
        id: uuidv4(),
        bgImg: Bg2,
        icon: Icon2,
        heading: 'Rapid Prototyping & Product Design',
        text: 'Transform your ideas into physical prototypes quickly and efficiently, enabling faster product development and design validation. Comprehensive product design services from initial concept through to production-ready specifications.',
        btnText: 'Learn More',
        link: '/services/rapid-prototyping',
    },

    {
        id: uuidv4(),
        bgImg: Bg3,
        icon: Icon3,
        heading: 'Industrial Equipment & Machine Design',
        text: 'Specialised design solutions for industrial machinery and equipment, optimised for performance, safety, and reliability.',
        btnText: 'Learn More',
        link: '/services/industrial-equipment',
    },

    {
        id: uuidv4(),
        bgImg: Bg4,
        icon: Icon4,
        heading: 'Manufacturing Consulting & ISO Conformance',
        text: 'Strategic consulting for production process optimisation, high-efficiency labour planning, and ISO conformance to enhance your manufacturing operations. Precision manufacturing of industrial components with expert sourcing and plating services.',
        btnText: 'Learn More',
        link: '/services/manufacturing-consulting',
    },
];

export default servicesOneData;
